
/* ---- gentle scroll parallax (about page) ---- */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var els = [].slice.call(document.querySelectorAll('.px'));
  if(reduce || !els.length) return;
  var ticking = false;
  function update(){
    var vh = window.innerHeight || 800;
    for(var i=0;i<els.length;i++){
      var el = els[i], r = el.getBoundingClientRect();
      if(r.bottom < -300 || r.top > vh + 300) continue;
      var mid = r.top + r.height/2;
      var p = (mid - vh/2) / vh;                 /* -1 .. 1 */
      var s = parseFloat(el.getAttribute('data-px')) || 0;
      el.style.transform = 'translate3d(0,' + (p * s * 100).toFixed(1) + 'px,0)';
    }
    ticking = false;
  }
  function onScroll(){
    if(!ticking){ ticking = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  window.addEventListener('hashchange', function(){ setTimeout(update, 60); });
  update();
})();
